module.exports = __webpack_public_path__ + "614952a95e136417df7e83ca3909a616.fbx";